module.exports = __webpack_public_path__ + "static/media/insufficient-points.72b53024.png";